<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10zGGVG/tc-custom/9781504079259.jpg?1705766050787" alt="This image is the cover for the book Last Quinn Standing, The Quinn Saga"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Quinn Standing, The Quinn Saga
      </h1>
      <p class="bookDescription body article font2">
        <b>A young man journeys from rural Mississippi to the battlefields of WWI to discover his family’s bloody legacy in this sequel to <i>By Accident of Birth</i>.</b><br/><br/> On May 7, 1915, the passenger ship RMS<i> Lusitania</i> was sunk by a German U-Boat. Among the many casualties was Beverly Bethany Quinn, an American woman whose entire life was marked by the forces of bloodshed. For Ansel Quinn, the single event holds a grim double meaning. With his beloved aunt gone, he is the last of his family line. And now his country is on the brink of joining the war overseas.<br/><br/> When Ansel discovers his Aunt Bethany’s diary, the shocking revelations within set him on an epic quest for family honor and self-discovery. President Wilson had vowed to keep America out of another war. Ansel had sworn to serve his country. Fate’s cards trumped them all. From the American South to the trenches of Verdun, nothing will ever be the same again.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas E. Simmons
      </h2>
      
      <p class="authorDescription body article">Thomas E.&#160;Simmons grew up in Gulfport, Mississippi, and attended Marion Military Institute, the US Naval Academy, the University of Southern Mississippi, and the University of Alabama. He has been a pilot since the age of sixteen and has participated in air shows, flying aerobatics in open-cockpit biplanes. In the late 1950s, Simmons served as an artillery officer in Korea. He is the author of <I>The Man Called Brown Condor</I>, x<I>Forgotten Heroes of World War II</I>, <I>Escape from Archangel</I>, and the Quinn Saga. Simmons has also written numerous magazine articles and has been published in <I>The Oxford American</I>.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fae3974